/**
 * Helper for composing multiple mutations
 */
export function compose(...args) {
	return function(...mutationArgs) {
		const mutations = args.filter((mutation) => typeof mutation === 'function');
		mutations.forEach((mutation) => mutation.apply(this, mutationArgs));
	};
}
